import React from "react";
import { Row, Container } from "reactstrap";

function DemoFooter() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          {/* Inizio navbar nel footer */}
          <nav className="footer-nav">
            <ul>
              <li>
                <a href="#">Guida Node JS</a>
              </li>
            </ul>
          </nav>
          {/* Fine navbar nel footer */}

          {/* Inizio autore */}
          <div className="credits ml-auto">
            <span className="copyright">
              © 2023, Guida realizzata da Bracco Mattia
            </span>
          </div>
          {/* Fine autore */}
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;
